
export const userColumns = [
 
    {
      field: "departmentName",
      headerName: "Department Name",
      width: 200,
    },
    {
      field: "departmentCode",
      headerName: "Department Code",
      width: 200,
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 200,
    },
  
   
    {
      field: "description",
      headerName: "Description",
      width: 200,
     
    },
   
  ];
  